import { Breadcrumb, Col, Row } from "antd";
import Title from "../UI/Title/Title";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import AddButton from "../UI/AddButton/addbutton";
import ResetButton from "../UI/ResetButton/resetbutton";
import { Search } from "../UI/Search/Search";
import SalesList from "./salesList";
import { useState } from "react";
import { getSalesReturns } from "../../api/salesReturn";
import { useMutation } from "react-query";

function Sales() {
  const { t } = useTranslation("common");
  const [search, setSearch] = useState<string>("");
  const [salesData, setSalesData] = useState<[]>();
  const [page, setPage] = useState<number>(1);
  const [tableKey, setTableKey] = useState("");

  const resetFilters = () => {
    getSalesData({
      limit: page * 10 + 10,
      q: "",
    }).then((res) => {
      setSalesData(res.data.data);
      setSearch("");
      setTableKey((tableKey) => tableKey + 1);
    });
  };

  const handleSearch = () => {
    getSalesData({
      limit: page * 10 + 10,
      q: search,
    }).then((res: any) => {
      setSalesData(res.data.data);
    });
  };

  const getSalesData = async (params: {
    limit: number;
    q: string;
    isActive?: boolean;
  }) => {
    // Make your API request here using the updated parameters
    return await SalesDataMutation(params);
  };

  const { mutateAsync: SalesDataMutation, isLoading: isSalesDataLoading } =
    useMutation("getSalesReturns", getSalesReturns);

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col offset={1} span={20}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("sales")}</>,
              },
              {
                title: (
                  <>
                    <span className="breadcrumbcolor">
                      {" "}
                      {t("returns-list")}{" "}
                    </span>
                  </>
                ),
              },
            ]}
          />
        </Col>
        <Col offset={1} span={22}>
          <Title title={`${t("sales-list")}`} />
        </Col>
        <Col offset={1} span={4}>
          <Search
            value={search}
            onKeyPress={(e: any) => e.code === "Enter" && handleSearch()}
            onChange={(e: any) => setSearch(e.target.value)}
            onEnter={() => {
              handleSearch();
            }}
          />
        </Col>
        <Col
          offset={12}
          span={6}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>
          <AddButton onClick={() => ""} />
        </Col>
        <Col offset={1} span={22}>
          <SalesList
            isSalesDataLoading={isSalesDataLoading}
            SalesDataMutation={SalesDataMutation}
            salesData={salesData}
            setSalesData={setSalesData}
            setPage={setPage}
            tableKey={tableKey}
            page={page}
            search={search}
          />
        </Col>
      </Row>
    </>
  );
}

export default Sales;
